<div class="study-link-picker bpx-section">
  <!-- Currently linked studies -->
  @if (linkedRunNames.length) {
  <div class="linkpicker-chips">
    @for (name of linkedRunNames; track name) {
    <span class="linkpicker-chip">
      <span class="linkpicker-chip-text" [matTooltip]="name" matTooltipShowDelay="300">{{ name }}</span>
      <button type="button" class="linkpicker-chip-remove" (click)="removeLink(name)" [attr.aria-label]="'Remove link ' + name">
        <mat-icon>cancel</mat-icon>
      </button>
    </span>
    }
  </div>
  } @else {
  <p class="bpx-empty">No linked studies yet. Search below to add some.</p>
  }

  <!-- Search controls (mirrors the Load Study dialog) -->
  <div class="linkpicker-search-row">
    <div class="bpx-control">
      <span class="bpx-control__label" id="linkpicker-panel-label">Panels</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
        <mat-select [(value)]="selectedPanelName" (selectionChange)="panelChangeAction()" aria-labelledby="linkpicker-panel-label">
          @for (panel of panels; track panel) {
          <mat-option [value]="panel.panelName">{{ panel.panelName }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="bpx-control">
      <span class="bpx-control__label" id="linkpicker-phase-label">Phases</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
        <mat-select [disabled]="!selectedPanelName" [(value)]="selectedPhaseType" (selectionChange)="phaseChangeAction()" aria-labelledby="linkpicker-phase-label">
          <mat-option *ngFor="let phaseType of phaseTypes" [value]="phaseType.value">{{ phaseType.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="bpx-control">
      <span class="bpx-control__label" id="linkpicker-user-label">User</span>
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
        <mat-select [(value)]="selectedUserName" (selectionChange)="userChangeAction()" aria-labelledby="linkpicker-user-label">
          <mat-option [value]="undefined">All Users</mat-option>
          @for (user of users; track user.email) {
          <mat-option [value]="user.email">{{ user.first_name }} {{ user.last_name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  @if (!!errorMessage) {
  <div class="bpx-error" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
  }

  @if (isSearching) {
  <p class="bpx-empty">Searching...</p>
  } @else if (filteredResults.length > 0) {
  <div class="linkpicker-filter">
    <input matInput type="search" class="bpx-input" placeholder="Filter..." [(ngModel)]="filterText" (input)="applyFilter()" />
  </div>
  <div class="linkpicker-list bpx-scroll-card">
    @for (study of filteredResults; track study.run_name) {
    <div class="linkpicker-row" (click)="toggleLink(study.run_name)">
      <mat-checkbox [checked]="isLinked(study.run_name)" (click)="$event.stopPropagation()" (change)="toggleLink(study.run_name)"></mat-checkbox>
      <span class="linkpicker-name">
        <span class="linkpicker-name-text" [matTooltip]="study.run_name" matTooltipShowDelay="300">{{ study.run_name }}</span>
        <span *ngIf="study.is_draft" class="linkpicker-draft-label">(Draft)</span>
        <span *ngIf="study.is_committed" class="linkpicker-committed-label">(Committed)</span>
      </span>
      <span class="linkpicker-user" [matTooltip]="study.user ?? ''" matTooltipShowDelay="300">{{ study.user ?? '' }}</span>
      <span class="linkpicker-date">{{ study.date ? (study.date | date:'MM-dd-yyyy') : '' }}</span>
    </div>
    }
  </div>
  } @else if (hasSearched) {
  <p class="bpx-empty">No Studies Found</p>
  } @else {
  <p class="bpx-empty">Select a panel and phase to search for studies to link.</p>
  }
</div>
